module.exports = __webpack_public_path__ + "static/media/login-bg.61354e6e.jpg";